/**
 * URLs del Org Service para la página /org/api (infra/web.ts las inyecta como VITE_*). Sin barra final.
 * `undefined` en un build sin SST (tests, previews): la página lo muestra como "no configurada".
 */
import { stripTrailingSlash } from '../../../shared/url';

const trim = (u: string | undefined) => (u ? stripTrailingSlash(u) : undefined);
export const ORG_API_URL: string | undefined = trim(import.meta.env.VITE_ORG_API_URL);
export const ORG_MCP_URL: string | undefined = trim(import.meta.env.VITE_ORG_MCP_URL);
export const COGNITO_DOMAIN: string | undefined = import.meta.env.VITE_COGNITO_DOMAIN;
export const ORG_TOKEN_URL: string | undefined = COGNITO_DOMAIN ? `https://${COGNITO_DOMAIN}/oauth2/token` : undefined;
